export var ModalAnimationState;
(function (ModalAnimationState) {
    ModalAnimationState[ModalAnimationState["IDLE"] = 0] = "IDLE";
    ModalAnimationState[ModalAnimationState["FADE_IN"] = 1] = "FADE_IN";
    ModalAnimationState[ModalAnimationState["ALIVE"] = 2] = "ALIVE";
    ModalAnimationState[ModalAnimationState["FADE_OUT"] = 3] = "FADE_OUT";
    ModalAnimationState[ModalAnimationState["DEAD"] = 4] = "DEAD";
    ModalAnimationState[ModalAnimationState["MAX"] = 5] = "MAX";
})(ModalAnimationState || (ModalAnimationState = {}));
//# sourceMappingURL=type.js.map